

import { Copy, Check } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

interface ShareLinkTabProps {
  shareUrl: string;
  copied: boolean;
  onCopy: () => void;
}

export function ShareLinkTab({ shareUrl, copied, onCopy }: ShareLinkTabProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2">
        <Input
          value={shareUrl}
          readOnly
          className="flex-1"
          placeholder="Generating link..."
        />
        <Button 
          size="icon" 
          onClick={onCopy}
          variant="outline"
          disabled={!shareUrl}
          title="Copy to clipboard"
        >
          {copied ? (
            <Check className="h-4 w-4 text-green-500" />
          ) : (
            <Copy className="h-4 w-4" />
          )}
        </Button>
      </div>
      
      <p className="text-sm text-muted-foreground">
        When others open this link:
      </p>
      <ul className="text-sm text-muted-foreground list-disc pl-5 space-y-1">
        <li>Premium users can import with one click</li>
        <li>Free users will be prompted to upgrade</li>
        <li>Non-users will be invited to sign up</li>
      </ul>
    </div>
  );
}
